import React, { useRef, memo } from 'react';
import Placeholder from '@/components/Placeholder';
import placeholderImg from '@/assets/placeholder.png';
import { useEcharts } from '@/hooks';
const GraphContainer = memo((props) => {
    const chart = useRef(null);
    const { height = 210, config, isEmpty } = props;
    if (isEmpty) {
        return (<div style={{ height }}>
        <Placeholder text="暂无数据" imgUrl={placeholderImg} style={{ height: '100%' }}/>
      </div>);
    }
    useEcharts(chart, config);
    return <div ref={chart} style={{ width: '100%', height }}/>;
});
export default GraphContainer;
